export const commonWebUiVersion = '5.11.1';
